<template>
  <div class="small-program">
    <list v-if="status === 0" />
    <mini-program-authorize-info
      v-else-if="status > 0"
      title="小程序资料暂不可用"
      content="当小程序审核成功后，小程序资料才能被启用"
    />
  </div>
</template>
<script>
import MiniProgramAuthorizeInfo from '@/components/mini-program-authorize-info'
import list from './list'
import Utils from '@utils'
import { miniAuthStatusCheck } from '@utils/check-mini-program-authorize'
export default {
  components: {
    MiniProgramAuthorizeInfo,
    list
  },
  data () {
    return {
      status: false
    }
  },
  created () {
    this.getMiniAuthStatus()
  },
  methods: {
    // 获取小程序审核状态
    async getMiniAuthStatus () {
      this.status = await miniAuthStatusCheck()
    }
  }
}
</script>
<style lang="scss" scoped>
  .small-program {
    width: 100%;
    height: 100%;
  }
</style>
